export default __webpack_public_path__ + "static/respo-e05bd73aab8c885cdadeaf51a116b679.svg";